<template>
  <div
    v-if="model.numberLabel === ''"
    :key="componentKey"
    :class="'Q' + model.id + 'Agency'"
  >
    <div class="col-md-12 checkmark-container">
      <strong class="checkmark-label">{{ model.text }}</strong>
      <div class="form-group mt-4">
        <div class="input-group custom-checkbox ml-n3">
          <template v-for="item in model.answers">
            <div :key="'divchkb' + item.id" class="form-group col-md-4 info">
              <div class="custom-control custom-checkbox">
                <input
                  :id="'chkb' + item.id"
                  v-model="item.selected"
                  type="checkbox"
                  class="custom-control-input"
                  :value="item.id"
                  :checked="model.selected === item.id"
                  :disabled="isReadOnly || model.disabled"
                  @change="onClickButton()"
                />
                <label
                  class="custom-control-label checkmark-label"
                  style="font-weight: normal;"
                  :for="'chkb' + item.id"
                >
                  {{ item.text }}
                </label>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped src="@/assets/css/component/radio-button.css"></style>
<script>
export default {
  props: {
    model: {
      type: Object,
      default: function() {
        return { disabled: false };
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentKey: 0,
      isReadOnly: this.readonly,
    };
  },
  methods: {
    onClickButton() {
      this.$emit('selectedCheck', this.model);
    },
    validate() {},
  },
  watch: {
    readonly: function() {
      this.isReadOnly = this.readonly;
    },
  },
};
</script>

<style scoped>
.info {
  text-align: left;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2db782;
  background-color: #2db782;
}

.checkmark-label {
  text-align: left;
  font: Regular 14px/17px Lato;
  letter-spacing: 0;
  color: #414141;
  opacity: 1;
}

.checkmark-container {
  background: #f4f6f3;
  margin-left: 64px;
  width: 86%;
  padding: 27px 10px 10px 32px;
}
</style>
